import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// import PDFViewer from '../components/PDFViewer';
import SimplePDFViewer from '../components/SimplePDFViewer';
import { fetchPDF } from '../services/api';

export default function ViewPDF() {
  const [searchParams] = useSearchParams();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get('token');
    console.log('🎯 ViewPDF: Token extrait de l\'URL:', token ? 'Présent' : 'Manquant');

    if (!token) {
      setError('Token manquant dans l\'URL');
      setLoading(false);
      return;
    }

    console.log('📥 ViewPDF: Début récupération PDF...');
    
    // Récupérer le PDF (retourne un objet avec url et httpHeaders)
    fetchPDF(token)
      .then((pdfConfig) => {
        console.log('✅ ViewPDF: Configuration PDF récupérée:', pdfConfig);
        setPdfUrl(pdfConfig);
        setLoading(false);
      })
      .catch((err) => {
        console.error('❌ ViewPDF: Erreur:', err);
        setError(err.message);
        setLoading(false);
      });

    // Cleanup : révoquer l'URL du blob quand le composant est démonté
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [searchParams]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-medium">Vérification du token...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-red-50 to-orange-50 p-4">
        <div className="text-center max-w-lg p-8 bg-white rounded-2xl shadow-2xl">
          <svg className="w-24 h-24 mx-auto mb-6 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">🚫 Accès refusé</h2>
          <p className="text-lg text-gray-700 mb-6">{error}</p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              <strong>💡 Que faire ?</strong><br/>
              Veuillez contacter le webmaster pour obtenir un nouveau lien d'accès.
            </p>
          </div>
          
          <div className="text-sm text-gray-500">
            <p>📧 Contact : <a href="mailto:contact@example.com" className="text-primary-600 hover:underline">contact@example.com</a></p>
          </div>
        </div>
      </div>
    );
  }

  return <SimplePDFViewer pdfConfig={pdfUrl} />;
}
